import CourseListBlock from "../Components/Modules/CourseList/CourseListBlock";
import { useEffect, useState } from "react";
import CourseBlockInterface from "../Interfaces/CourseBlockInterface";
import Collection from "../Api/ReadCollection";

const AuthorCoursesPage = () => {
  // const [blockList, setBlockList] = useState<Array<CourseBlockInterface>>([]);
  const [courseList, setCourseList] = useState<
    Array<CourseBlockInterface> | Record<string, any>[]
  >([]);

  const indexList = JSON.parse(localStorage.getItem("author_courses") || "{}");

  const fetchCourse: any = Collection.readCollection("Course") || [];

  async function fetchCourseList() {
    let rawList = await fetchCourse;

    const result = rawList.filter((item: { id: string; }) => indexList.includes(item.id));

    setCourseList(result);
  }

  useEffect(() => {
    fetchCourseList();
  }, []);

  return (
    <div className="coursesListPage">
      <div className="coursesList">
        <div className="coursesListContent">
          {courseList.map((item, index) => {
            return (
              <CourseListBlock
                key={index}
                id={item.id}
                title={item.title}
                description={item.description}
                duration={item.duration}
                hours={item.hours}
                document_name={item.document_name}
                track_list={item.track_list}
                modules={item.modules}
                layout={item.layout}
                background_color={item.background_color}
                background_non_color={item.background_non_color}
                suitable={item.suitable}
              />
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default AuthorCoursesPage;
